import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const DesignEditorHeader = ({ className, children }) => {
  const classes = classNames({
    'design-editor-header': true,
    [className]: !!className,
  });

  return <div className={classes}>{children}</div>;
};

DesignEditorHeader.propTypes = propTypes;

export default DesignEditorHeader;
